import { Route, RouteConfig } from 'vue-router';
import { WmsPageComposer } from '../components/page-composer/page-composer';
import { router } from './router';

export const KP_URL = 'komercni-prostory';

export const KP_ROUTES: RouteConfig[] = [
	{
		path: '/page/komerce-uvod',
		name: 'komerce-uvod',
		meta: { kpRedirect: '/' },
		props: { pageUrl: 'komerce-uvod' },
		component: WmsPageComposer
	},


	{
		path: '/page/komerce-152-999',
		name: 'komerce-152-999',
		alias: '/komerce-152-999',
		meta: { kpRedirect: '/komerce-152-999' },
		props: { pageUrl: 'komerce-152-999' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-152-998',
		name: 'komerce-152-998',
		alias: '/komerce-152-998',
		meta: { kpRedirect: '/komerce-152-998' },
		props: { pageUrl: 'komerce-152-998' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-152-997',
		name: 'komerce-152-997',
		alias: '/komerce-152-997',
		meta: { kpRedirect: '/komerce-152-997' },
		props: { pageUrl: 'komerce-152-997' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-152-996',
		name: 'komerce-152-996',
		alias: '/komerce-152-996',
		meta: { kpRedirect: '/komerce-152-996' },
		props: { pageUrl: 'komerce-152-996' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-990',
		name: 'komerce-189-990',
		alias: '/komerce-189-990',
		meta: { kpRedirect: '/komerce-189-990' },
		props: { pageUrl: 'komerce-189-990' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-989',
		name: 'komerce-189-989',
		alias: '/komerce-189-989',
		meta: { kpRedirect: '/komerce-189-989' },
		props: { pageUrl: 'komerce-189-989' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-986',
		name: 'komerce-189-986',
		alias: '/komerce-189-986',
		meta: { kpRedirect: '/komerce-189-986' },
		props: { pageUrl: 'komerce-189-986' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-988',
		name: 'komerce-189-988',
		alias: '/komerce-189-988',
		meta: { kpRedirect: '/komerce-189-988' },
		props: { pageUrl: 'komerce-189-988' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-987',
		name: 'komerce-189-987',
		alias: '/komerce-189-987',
		meta: { kpRedirect: '/komerce-189-987' },
		props: { pageUrl: 'komerce-189-987' },
		component: WmsPageComposer
	},

	{
		path: '/page/komercni-prostory-152',
		name: 'komercni-prostory-152',
		alias: '/komercni-prostory-152',
		meta: { kpRedirect: '/komercni-prostory-152' },
		props: { pageUrl: 'komercni-prostory-152' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-standardy-152',
		name: 'komerce-standardy-152',
		alias: '/komerce-standardy-152',
		meta: { kpRedirect: '/komerce-standardy-152' },
		props: { pageUrl: 'komerce-standardy-152' },
		component: WmsPageComposer
	},



	{
		path: '/page/komerce-107-999',
		name: 'komerce-107-999',
		alias: '/komerce-107-999',
		meta: { kpRedirect: '/komerce-107-999' },
		props: { pageUrl: 'komerce-107-999' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-125-995',
		name: 'komerce-125-995',
		alias: '/komerce-125-995',
		meta: { kpRedirect: '/komerce-125-995' },
		props: { pageUrl: 'komerce-125-995' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-125-996',
		name: 'komerce-125-996',
		alias: '/komerce-125-996',
		meta: { kpRedirect: '/komerce-125-996' },
		props: { pageUrl: 'komerce-125-996' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-125-997',
		name: 'komerce-125-997',
		alias: '/komerce-125-997',
		meta: { kpRedirect: '/komerce-125-997' },
		props: { pageUrl: 'komerce-125-997' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-125-998',
		name: 'komerce-125-998',
		alias: '/komerce-125-998',
		meta: { kpRedirect: '/komerce-125-998' },
		props: { pageUrl: 'komerce-125-998' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-125-999',
		name: 'komerce-125-999',
		alias: '/komerce-125-999',
		meta: { kpRedirect: '/komerce-125-999' },
		props: { pageUrl: 'komerce-125-999' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-991',
		name: 'komerce-189-991',
		alias: '/komerce-189-991',
		meta: { kpRedirect: '/komerce-189-991' },
		props: { pageUrl: 'komerce-189-991' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-992',
		name: 'komerce-189-992',
		alias: '/komerce-189-992',
		meta: { kpRedirect: '/komerce-189-992' },
		props: { pageUrl: 'komerce-189-992' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-993',
		name: 'komerce-189-993',
		alias: '/komerce-189-993',
		meta: { kpRedirect: '/komerce-189-993' },
		props: { pageUrl: 'komerce-189-993' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-995',
		name: 'komerce-189-995',
		alias: '/komerce-189-995',
		meta: { kpRedirect: '/komerce-189-995' },
		props: { pageUrl: 'komerce-189-995' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-996',
		name: 'komerce-189-996',
		alias: '/komerce-189-996',
		meta: { kpRedirect: '/komerce-189-996' },
		props: { pageUrl: 'komerce-189-996' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-997',
		name: 'komerce-189-997',
		alias: '/komerce-189-997',
		meta: { kpRedirect: '/komerce-189-997' },
		props: { pageUrl: 'komerce-189-997' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-998',
		name: 'komerce-189-998',
		alias: '/komerce-189-998',
		meta: { kpRedirect: '/komerce-189-998' },
		props: { pageUrl: 'komerce-189-998' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-189-999',
		name: 'komerce-189-999',
		alias: '/komerce-189-999',
		meta: { kpRedirect: '/komerce-189-999' },
		props: { pageUrl: 'komerce-189-999' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-192-992',
		name: 'komerce-192-992',
		alias: '/komerce-192-992',
		meta: { kpRedirect: '/komerce-192-992' },
		props: { pageUrl: 'komerce-192-992' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-192-993',
		name: 'komerce-192-993',
		alias: '/komerce-192-993',
		meta: { kpRedirect: '/komerce-192-993' },
		props: { pageUrl: 'komerce-192-993' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-192-994',
		name: 'komerce-192-994',
		alias: '/komerce-192-994',
		meta: { kpRedirect: '/komerce-192-994' },
		props: { pageUrl: 'komerce-192-994' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-192-995',
		name: 'komerce-192-995',
		alias: '/komerce-192-995',
		meta: { kpRedirect: '/komerce-192-995' },
		props: { pageUrl: 'komerce-192-995' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-192-996',
		name: 'komerce-192-996',
		alias: '/komerce-192-996',
		meta: { kpRedirect: '/komerce-192-996' },
		props: { pageUrl: 'komerce-192-996' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-192-997',
		name: 'komerce-192-997',
		alias: '/komerce-192-997',
		meta: { kpRedirect: '/komerce-192-997' },
		props: { pageUrl: 'komerce-192-997' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-192-998',
		name: 'komerce-192-998',
		alias: '/komerce-192-998',
		meta: { kpRedirect: '/komerce-192-998' },
		props: { pageUrl: 'komerce-192-998' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-standardy-107',
		name: 'komerce-standardy-107',
		alias: '/komerce-standardy-107',
		meta: { kpRedirect: '/komerce-standardy-107' },
		props: { pageUrl: 'komerce-standardy-107' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-standardy-125',
		name: 'komerce-standardy-125',
		alias: '/komerce-standardy-125',
		meta: { kpRedirect: '/komerce-standardy-125' },
		props: { pageUrl: 'komerce-standardy-125' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-standardy-189',
		name: 'komerce-standardy-189',
		alias: '/komerce-standardy-189',
		meta: { kpRedirect: '/komerce-standardy-189' },
		props: { pageUrl: 'komerce-standardy-189' },
		component: WmsPageComposer
	},
	{
		path: '/page/komerce-standardy-192',
		name: 'komerce-standardy-192',
		alias: '/komerce-standardy-192',
		meta: { kpRedirect: '/komerce-standardy-192' },
		props: { pageUrl: 'komerce-standardy-192' },
		component: WmsPageComposer
	},
	{
		path: '/page/komercni-prostory-107',
		name: 'komercni-prostory-107',
		alias: '/komercni-prostory-107',
		meta: { kpRedirect: '/komercni-prostory-107' },
		props: { pageUrl: 'komercni-prostory-107' },
		component: WmsPageComposer
	},
	{
		path: '/page/komercni-prostory-125',
		name: 'komercni-prostory-125',
		alias: '/komercni-prostory-125',
		meta: { kpRedirect: '/komercni-prostory-125' },
		props: { pageUrl: 'komercni-prostory-125' },
		component: WmsPageComposer
	},
	{
		path: '/page/komercni-prostory-189',
		name: 'komercni-prostory-189',
		alias: '/komercni-prostory-189',
		meta: { kpRedirect: '/komercni-prostory-189' },
		props: { pageUrl: 'komercni-prostory-189' },
		component: WmsPageComposer
	},
	{
		path: '/page/komercni-prostory-192',
		name: 'komercni-prostory-192',
		alias: '/komercni-prostory-192',
		meta: { kpRedirect: '/komercni-prostory-192' },
		props: { pageUrl: 'komercni-prostory-192' },
		component: WmsPageComposer
	}	
];

export function kpGuard(to: Route, _from: Route, next: Function): boolean {
	if (window.location.href.indexOf(KP_URL) > -1 && to.meta.kpRedirect) {
		if (to.meta.kpRedirect !== to.fullPath) {
			next({ path: to.meta.kpRedirect, replace: true });
			return true;
		}
	}

	if (window.location.href.indexOf(KP_URL) === -1 && to.meta.kpRedirect) {
		next({ path: '/nenalezeno', replace: true });
		return true;
	}

	if (
		window.location.href.indexOf(KP_URL) > -1 &&
		to.fullPath !== '/' &&
		!to.meta.kpRedirect
	) {
		const { afterClick } = (router as any).meta;

		// send all other route requets as HTTP GET requests
		if (afterClick) {
			window.location.href = to.fullPath;
		} else {
			window.location.href = `https://www.central-group.cz/nenalezeno.html`;
		}

		return true;
	}

	return false;
}
